<template>
    <div>
        <div v-if="isLoaded" class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
            <div v-if="errors.redirectUrl"  class="form-group py-5 py-md-3">
                <div class="is-invalid"></div>
                <div class="invalid-feedback">{{ $t('errors.' + errors.redirectUrl) }}</div>
            </div>
            <div v-else>
                <div class="text-center p-2">
                    <h3>{{ $t('account.2sa.loginTitle') }}</h3>
                </div>

                <div class="text-center p-2">
                    <p v-if="isClientLogin()" class="text-nowrap" v-html="$t('auth.client.' + clientName)"></p>
                </div>

                <div class="tab-content p-2">
                    <div class="tab-pane fade show active" id="tab-login" role="tabpanel"
                        aria-labelledby="pills-login-tab">
                        <form @submit.prevent="handleOnSubmit">
                            <div class="form-group">
                                <label for="oneTimeCode">{{ $t('account.2sa.enterOneTimeCode') }}</label>
                                <input v-model="formData.oneTimeCode" type="text" id="oneTimeCode" name="oneTimeCode" class="form-control"
                                    v-bind:class="{ 'is-invalid': errors.oneTimeCode}"/>
                                <div v-if="errors.oneTimeCode" class="invalid-feedback">{{ $t('errors.' + errors.oneTimeCode) }}</div>
                            </div>

                            <div class="text-center p-2">
                                <button type="submit" class="btn btn-primary">{{ $t('account.2sa.submit') }}</button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import userService from '../../services/UserService';
    
    export default {
        name: 'google-login-module',

        components: {

        },

        async mounted() {
            this.loadSessionStorage();
            // 遷移元がログイン画面かつ、ログインパスワード認証成功でない場合はログイン画面へ遷移
            if (! this.isSuccessLogin) {
                this.$router.push("/login");
                return;
            }

            // クライアントログインの場合
            if (this.isClientLogin()) {
                // リダイレクト先URL（認証クライアント）のチェック
                try {
                    const result =  
                        await userService.getClientName(
                            this.redirectUrl
                        );
                    this.clientName = result.data.clientName;
                } catch (error) {
                    error.response.data.errors.forEach(error => {
                        if (error.field) {
                            this.errors[error.field] = error.message[0];
                        }
                    });
                }
            }

            this.isLoaded = true;

        },

        data() {
            return {
                errors: this.getDefaultErrors(),
                formData: this.getDefaultFields(),
                clientName: null,
                loginData: null,
                redirectUrl: null,
                queryString: '',
                isLoaded: false,
            }
        },

        methods: {
            getDefaultFields() {
                return {
                    oneTimeCode: '',
                    google2saToken: '',
                    userId: '',
                }
            },

            getDefaultErrors() {
                return {
                    oneTimeCode: '',
                }
            },

            async handleOnSubmit(e) {
                let isReady = this.checkInputValue();
                if (! isReady) return;

                try {
                    const result = await userService.google2saLogin(this.formData);

                    userService.setLogin(this.isClientLogin() ? result.data.aube : result.data);
                    const user = (await userService.getUserFrontendData(true)).data;

                    if (this.isClientLogin()) {
                        // クライアントログインの場合はリダイレクト先URLへ遷移する
                        this.clientOnetimeToken = result.data.client.onetimeToken;
                        this.redirectToClientUrl()
                    } else if (user.is_child && !user.changed_password) {
                        this.$router.push('/child/change-password');
                    } else {
                        if (!user.is_child) {
                            this.$router.push('/');
                        } else {
                            this.$router.push('/studies-top');
                        }
                    }
                } catch (error) {
                    error.response.data.errors.forEach(error => {
                        if (error.field) {
                            console.log(error.message[0]);
                            this.errors[error.field] = error.message[0];
                        }
                    });
                }
            },

            /**
             * 入力値検証
             * @returns bool
             */
            checkInputValue() {
                // エラーを全てクリア
                this.errors = this.getDefaultFields();

                if (!this.formData.oneTimeCode.trim()) {
                    this.errors.oneTimeCode = 'ONE_TIME_CODE_SHOULD_NOT_EMPTY';
                    return false;
                }
                return true;
            },

            isClientLogin() {
                return !!this.redirectUrl
            },

            async redirectToClientUrl() {
                this.clientSiteRedirecting = true;
                if (this.clientRedirectQuery()) {
                    window.location.replace(this.redirectUrl + "?" + this.clientRedirectQuery());
                } else {
                    window.location.replace(this.redirectUrl);
                }
            },

            clientRedirectQuery() {
                // リダイレクト時に渡すクエリストリングを返す
                return this.queryString + '&token=' + this.clientOnetimeToken;
            },

            loadSessionStorage() {
                // sessionStorageのプロパティは画面遷移で文字列に変化してしまう？
                if (sessionStorage.redirectUrl !== "undefined" && sessionStorage.redirectUrl !== "null") {
                    this.redirectUrl = sessionStorage.redirectUrl;
                } 
                this.loginData = JSON.parse(sessionStorage.loginData);
                this.formData.google2saToken = this.loginData.google2saToken;
                this.formData.userId = this.loginData.user_id;
                this.queryString = sessionStorage.queryString;
            },
        },

        computed: {
            isSuccessLogin: function() {
                return this.$router.referrer.path === "/login" 
                    && this.loginData.user_id
                    && this.loginData.google2saActive === true
                    && this.loginData.google2saToken
                    && this.loginData.expires_at;
            }
        }
    }
</script>

